var map = {
	"./reply.svg": "e1eb",
	"./rexam.svg": "7d11",
	"./rfile.svg": "f338",
	"./rlink.svg": "0a40",
	"./ronline.svg": "a2ea",
	"./rpdf.svg": "63f3",
	"./rsurvey.svg": "b87c",
	"./rtrain.svg": "1bce",
	"./rvideo.svg": "d51c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "12ef";